"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIVE_BAUD_BIT_TIME_MS = void 0;
exports.build5BaudDataBits = build5BaudDataBits;
exports.send5BaudInit = send5BaudInit;
const delay_1 = require("./delay");
const lineControl_1 = require("./lineControl");
exports.FIVE_BAUD_BIT_TIME_MS = 200;
function build5BaudDataBits(value) {
    const masked = value & 0xff;
    return (masked << 1) | 0x0200;
}
async function send5BaudInit(transport, value, options = {}) {
    const { setDtr = false, bothLines = false, bitTimeMs = exports.FIVE_BAUD_BIT_TIME_MS, autoKeyByteDelay = 0 } = options;
    await (0, lineControl_1.withLineControl)(transport, {
        setDtr,
        setRts: bothLines,
        sendPulse: async (pulseTransport) => {
            await pulseTransport.sendPulse?.(build5BaudDataBits(value), 10, bitTimeMs, setDtr, bothLines, autoKeyByteDelay);
        }
    }, async () => {
        const bits = buildBitSequence(value);
        for (const bit of bits) {
            if (bit === 0) {
                await transport.setBreak(bitTimeMs);
            }
            else {
                await transport.setBreak(0);
                await (0, delay_1.delay)(bitTimeMs);
            }
        }
    });
}
function buildBitSequence(value) {
    const masked = value & 0xff;
    const bits = [0];
    for (let i = 0; i < 8; i += 1) {
        bits.push((masked >> i) & 0x01);
    }
    bits.push(1);
    return bits;
}
//# sourceMappingURL=slowInit.js.map